import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const ReferralSettings = () => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/referral").then((r) => setF(r.data)); }, []);
  if (!f) return null;
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const r = await api.put("/settings/referral", { enabled: f.enabled, rewardSessions: Number(f.rewardSessions), headline: f.headline, blurb: f.blurb }); setF(r.data); toast.success("Referral program saved"); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <form className="panel" onSubmit={save} data-testid="referral-settings-form">
      <h3>Referral rewards · clients share a link, friends become leads, referrers earn free sessions</h3>
      <label className="chk" style={{ display: "flex", alignItems: "center", gap: 8, margin: "4px 0 8px" }}><input type="checkbox" checked={!!f.enabled} onChange={(e) => setF({ ...f, enabled: e.target.checked })} style={{ width: "auto" }} data-testid="referral-enabled-toggle" /> Referral program on — "Refer a friend" card shows on every client's Home</label>
      <div className="frow">
        <div><label>Free sessions per converted referral</label><input type="number" min={0} max={10} value={f.rewardSessions} onChange={(e) => setF({ ...f, rewardSessions: e.target.value })} data-testid="referral-reward-input" /></div>
        <div><label>Landing headline · {"{coach}"} = your business</label><input value={f.headline} onChange={(e) => setF({ ...f, headline: e.target.value })} maxLength={80} data-testid="referral-headline-input" /></div>
      </div>
      <label>Landing blurb · {"{referrer}"} and {"{coach}"} are filled in</label>
      <input value={f.blurb} onChange={(e) => setF({ ...f, blurb: e.target.value })} maxLength={300} data-testid="referral-blurb-input" />
      <div className="ss" style={{ marginTop: 6 }}>Reward is added the moment you tap "Add as client" on a lead (Clients → Referrals). Set 0 to run referrals without an automatic reward.</div>
      <div className="mfoot" style={{ justifyContent: "flex-start" }}><button className="btn sm" disabled={busy} data-testid="referral-settings-save">Save referral program</button></div>
    </form>
  );
};
